import React from "react"
import get from "lodash.get";
const TableRowCell = ({ item, column, index }) => {
    const value = get(item, column.key);
    return (
        <td>{column.render ? column.render(item, index) : value}</td>
    );
}
export default TableRowCell;